import { TagInput as UiTagInput } from '@ledgerloom/ui';

// Tags as removable chips (the library's), labelled by the field around them. A leading # is dropped.
export function TagInput({ id, value, onChange, placeholder, quiet, ...aria }: {
  id?: string; value: string[]; onChange: (tags: string[]) => void; placeholder?: string; quiet?: boolean;
  'aria-describedby'?: string; 'aria-invalid'?: boolean;
}) {
  const tidy = (tags: string[]) => [...new Set(tags.map((t) => t.replace(/^#/, '')).filter(Boolean))];
  return <UiTagInput id={id} value={value} onValueChange={(tags) => onChange(tidy(tags))} placeholder={placeholder} quiet={quiet} {...aria} />;
}
